import { ENTITY_TYPE_PROVIDER, VIEW_DOCUMENTS_TITLE } from "../../../../globalConstants.js";
import useStore from "../../../../lib/itn-ui-kit/data/store.js";
import BaseRoute from "../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../lib/itn-ui-kit/services/service-container.js";
import ApiRequestErrorHandler from "../../../components/global/ApiRequestErrorHandler.js";
import { SelectOptionsProCliStatusDataProcessorRole } from "../../../components/global/FormComponents/SelectBasic/utils/SelectOptionsProCliStatusDataProcessorRole.js";
import { useDocumentListStore } from "../../../components/modules/Documents/ViewDocuments/hooks/useDocumentListStore.js";
import { userDBService } from "../../../components/ui library/helpers/dbInstances";

import Template from "./template";

export default class ViewDocumentRoute extends BaseRoute {
  @service("repositories/case-folder-repository") folderRepository;
  @service("repositories/document-repository") documentRepository;
  @service("repositories/document-validate-repository") documentValidateRepository;
  @service("repositories/provider-client-status-repository") providerClientStatusRepository;
  @service("repositories/appointment-repository") appointmentRepository;
  @service("repositories/case-repository") caseRepository;

  path = ":id";

  element = (<Template />);

  async loader({ params }) {
    const { id } = params;
    const userDetail = await userDBService.get("userDetail");
    const isProvider = userDetail?.entity?.entityTypeLabel === ENTITY_TYPE_PROVIDER;

    const folderStore = useDocumentListStore.getState();
    if (!folderStore.folderId) {
      folderStore.setFolderId(1);
    }

    const folderId = folderStore.folderId;

    const folders = await this.folderRepository.findRecord(id + "/" + folderId);
    const documentsOpts = await this.documentRepository.getOptions();
    const providersClient = await this.providerClientStatusRepository.query({ case: id });
    const providers = providersClient.map((client) => client?.provider);
    const documentValidation = await this.documentValidateRepository.get();
    const _case = await this.caseRepository.findRecord(id);
    const title = VIEW_DOCUMENTS_TITLE;

    const deleteDocument = async (docId) => await this.documentRepository.delete(docId);
    const patchDocument = async (docId, body) => await this.documentRepository.patch(docId, body);

    folderStore.setParentFolderId(folders.parentFolderId);
    folderStore.setTotalDocumentCount(folders.documents.length);

    const count = useStore.getState().getTotalCount("document");

    let managedProviderOptions = [];
    try {
      if (providersClient?.length > 0) {
        managedProviderOptions = await SelectOptionsProCliStatusDataProcessorRole(
          providersClient,
          isProvider,
          null
        );
      }
    } catch (error) {
      return ApiRequestErrorHandler(error.response);
    }

    return {
      title,
      _case,
      folders,
      documentsOpts,
      documentValidation,
      providers,
      deleteDocument,
      patchDocument,
      count,
      managedProviderOptions,
    };
  }
}
